import httpClient from '@/api/httpClient'
import { defineStore } from 'pinia'
import store from '@/store'
import { pick } from 'lodash'

export const useStyleMappingsStore = defineStore('styleMappings', {
  state: () => ({
    styleMappings: [],
    fetchInitiated: false,
  }),

  getters: {
    all({ styleMappings }) {
      return styleMappings
    },
  },

  actions: {
    async fetch(styleMapId) {
      this.fetchInitiated = true

      return httpClient.get(`/api/internal/style_maps/${styleMapId}/style_mapping`)
        .then(response => {
          this.styleMappings = response.data.style_mappings
        })
        .catch((err) => {
          store.dispatch('messages/smartAdd', err)
        })
    },

    async update({ styleMapId, styleMappings }) {
      const permittedStyleMappings = styleMappings.map((mapping) => {
        return pick(mapping, ['id', 'style_map_id', 'style', 'custom_name'])
      })

      return httpClient.patch(
        `/api/internal/style_maps/${styleMapId}/style_mapping`,
        { style_mappings: permittedStyleMappings }
      ).then(response => {
        this.styleMappings = response.data.style_mappings
        store.dispatch('messages/addNotice', response.data.message)
        return response
      }).catch((err) => {
        store.dispatch('messages/smartAdd', err)
      })
    },

    async fetchOnce(styleMapId) {
      if (this.fetchInitiated) return Promise.resolve()

      return this.fetch(styleMapId)
    },
  },
})
